// extracted by mini-css-extract-plugin
export default {"Input":"NumberInput_Input__Ulm5t"};